const MEDIA_ITEMS = [
  {
    id: 1,
    title: '蜜桃视频 · 夏日限定剧场',
    desc: '蜜桃视频今夏最火都市情感剧《盛夏之约》全集已上线，高颜值主演阵容，剧情甜度爆表。',
    duration: '全24集',
    platform: '蜜桃视频',
    img: 'https://readdy.ai/api/search-image?query=Warm%20peach%20and%20cream%20colored%20abstract%20gradient%20background%20with%20soft%20organic%20shapes%2C%20modern%20minimalist%20design%20with%20play%20button%20silhouette%2C%20gentle%20warm%20lighting%2C%20youthful%20and%20romantic%20atmosphere%2C%20clean%20aesthetic&width=640&height=360&seq=media-card-01&orientation=landscape',
    alt: '蜜桃视频夏日限定剧场',
  },
  {
    id: 2,
    title: '西瓜视频免费 · 爆款喜剧专场',
    desc: '西瓜视频免费平台经典喜剧电影大合集，沈腾、徐峥等喜剧大咖作品一网打尽，笑点不断。',
    duration: '更新至56部',
    platform: '西瓜视频免费',
    img: 'https://readdy.ai/api/search-image?query=Bright%20watermelon%20red%20and%20green%20abstract%20gradient%20with%20playful%20circular%20shapes%2C%20modern%20design%20with%20subtle%20entertainment%20vibe%2C%20energetic%20and%20fun%20atmosphere%2C%20clean%20minimal%20composition%20with%20warm%20tones&width=640&height=360&seq=media-card-02&orientation=landscape',
    alt: '西瓜视频免费爆款喜剧专场',
  },
  {
    id: 3,
    title: '香蕉视频 · 高分纪录片精选',
    desc: '香蕉视频平台口碑最好的自然纪录片《蓝色星球》系列，导演剪辑加长版上线，画质震撼。',
    duration: '系列共8集',
    platform: '香蕉视频',
    img: 'https://readdy.ai/api/search-image?query=Golden%20yellow%20and%20deep%20blue%20abstract%20gradient%20with%20organic%20flowing%20shapes%2C%20modern%20cinematic%20design%20with%20documentary%20film%20aesthetic%2C%20rich%20contrast%20and%20depth%2C%20elegant%20visual%20atmosphere&width=640&height=360&seq=media-card-03&orientation=landscape',
    alt: '香蕉视频高分纪录片精选',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            热门视频推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日精选各大水果视频在线平台热门内容，高清画质即点即看
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {MEDIA_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.classList.add('bg-background-200');
                    }
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 shadow-sm">
                    <i className="ri-play-fill text-xl md:text-2xl"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-1 rounded-md bg-foreground-950/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                    {item.platform}
                  </span>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-accent-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}